import {dispatch} from 'd3-dispatch';
import {setMethodsFromAttrs} from '../../modules/util';

import pointNum from './pointNum';
import zoom from './zoom';
import zoomExtent from './zoomExtent';
import zoomed from './zoomed';
import zoomGen from './zoomGen';
import zoomTransform from './zoomTransform';

const _attrs = {
  zoom : false,
  zoomGen: null
}

const zoomableMixin = Base => {
  let Zoomable = class extends Base {
    constructor(appendedAttrs) {
      for (let k in _attrs) {
        appendedAttrs[k] = _attrs[k];
      }
      super(appendedAttrs);
      this.__execs__.zoom = null;
      this.__execs__.zoomDispatch = dispatch('zoom');
      this.rebindOnMethod(this.__execs__.zoomDispatch);
    }
  }
  Zoomable.prototype.pointNum = pointNum;
  Zoomable.prototype.zoom = zoom;
  Zoomable.prototype.zoomed = zoomed;
  Zoomable.prototype.zoomExtent = zoomExtent;
  Zoomable.prototype.zoomGen = zoomGen;
  Zoomable.prototype.zoomTransform = zoomTransform;
  Zoomable.prototype.isBrushZoom = isBrushZoom;
  setMethodsFromAttrs(Zoomable, _attrs);
  return Zoomable;
}

function isBrushZoom() {
  return this.__attrs__.zoom && this.__attrs__.zoom === 'brush';
}


export default zoomableMixin;


// WEBPACK FOOTER //
// ./layouts/zoomable/index.js